export const pageNameArr = [
  {
    pageName: '单个包材样品',
    pageUrl: 'sample-manage/publish-package-sample',
    type: 'PACKING_MATERIAL',
    listDataParam: 'packingMaterialSampleVO'
  },
  {
    pageName: '单个ODM样品',
    pageUrl: 'sample-manage/publish-ODM-sample',
    type: 'ODM',
    listDataParam: 'odmSampleVO',
  },
  {
    pageName: '单个膜布样品',
    pageUrl: 'sample-manage/publish-membrane-sample',
    type: 'MEMBRANE_CLOTH',
    listDataParam: 'fabricSampleVO',
  },
  {
    pageName: '单个原料样品',
    pageUrl: 'sample-manage/publish-material-sample',
    type: 'RAW_MATERIAL',
    listDataParam: 'rawMaterialSampleVO',
  },
  {
    pageName: '单个赠品',
    pageUrl: 'sample-manage/publish-gift-sample',
    type: 'GIFT_MATERIAL',
    listDataParam: 'giftMaterialSampleVO'
  }
];

export const sampleVODetail = [
  {
    type: 'packingMaterialSampleVO',
    unit: '容量',
    btnTips: '样品数量不能超过5个',
    max: 5,
    name: 'package',
    sampleType: 'PACKING_MATERIAL',
    typeName: '包材',
    url: 'getPackingMaterialSample',
    unitName: '个',
  },
  {
    type: 'odmSampleVO',
    unit: '样品量（份）',
    btnTips: '样品数量不能超过10份',
    max: 10,
    name: 'ODM',
    sampleType: 'ODM',
    typeName: 'ODM',
    url: 'getODMSample',
    unitName: '份',
  },
  {
    type: 'giftMaterialSampleVO',
    unit: '样品量（份）',
    btnTips: '',
    name: 'GIFT',
    sampleType: 'GIFT_MATERIAL',
    typeName: 'GIFT',
    url: 'getGIFTSample',
    unitName: '份',
    hiden: true
  },
  {
    type: 'fabricSampleVO',
    unit: '样品量（张）',
    btnTips: '样品数量不能超过100张',
    max: 100,
    name: 'membrane',
    sampleType: 'MEMBRANE_CLOTH',
    typeName: '膜布',
    url: 'getFabric',
    unitName: '张',
  },
  {
    type: 'rawMaterialSampleVO',
    unit: '样品量（g）',
    btnTips: '样品量不能超过500g',
    max: 500,
    name: 'material',
    sampleType: 'RAW_MATERIAL',
    typeName: '原料',
    url: 'getRawMaterial',
    unitName: 'g',
  },
]

export function filterPage (type) {
  return pageNameArr.find(item => item.type === type);
}

export const pageStatus = [
  { name: '新增', status: 'add', disabled: false },
  { name: '修改', status: 'update', disabled: false },
  { name: '查看', status: 'detail', disabled: true },
  { name: '审核', status: 'verify', disabled: false },
  { name: '复制', status: 'copy', disabled: false },
];

// 产品品类
export const odmProductCategoryCmdsData = {
  allCategory: [
    '化妆水',
    '洁面',
    '润唇膏',
    '眼霜',
    '贴片面膜',
    '免洗式涂抹面膜',
    '洗去型涂抹面膜',
    '防晒',
    '鼻贴/祛痘贴',
    'T区护理',
    '男士洁面',
    '乳液面霜',
    '精华',
    '面部喷雾',
    '其它',
    '卸妆',
    '口红/唇釉',
    '粉底气垫',
    '隔离',
    '眼影眼线',
    '眉笔眉粉',
    '修容腮红',
    '睫毛膏',
    '化妆工具',
    '身体乳',
    '香水',
    '手霜手膜足膜',
    '美容仪',
    '美甲',
  ],
  COSMETIC: [
    '卸妆',
    '口红/唇釉',
    '粉底气垫',
    '隔离',
    '眼影眼线',
    '眉笔眉粉',
    '修容腮红',
    '睫毛膏',
    '化妆工具',
    '其它',
  ],
  SKIN_CARE: [
    '贴片面膜',
    '免洗式涂抹面膜',
    '洗去型涂抹面膜',
    '洁面',
    '男士洁面',
    '化妆水',
    '乳液面霜',
    '精华',
    '眼霜',
    '润唇膏',
    '防晒',
    '鼻贴/祛痘贴',
    'T区护理',
    '面部喷雾',
    '其它',
  ],
  COSMETOLOGY: [
    '身体乳',
    '香水',
    '手霜手膜足膜',
    '美容仪',
    '美甲',
    '其它',
  ],
  odmProductEfficacyCmdsData: [
    '清洁控油',
    '保湿补水',
    '美白提亮',
    '淡斑',
    '淡化细纹',
    '抗皱/抗衰/紧致',
    '收缩毛孔',
    '去黑眼圈',
    '舒敏修护',
    '祛痘消炎',
    '盈润透亮',
    '增加皮肤弹性',
    '抗污染/抗蓝光',
    '抗氧化/抗糖化',
    '其它',
  ]
}
